import { Skeleton } from '@mui/material'

export function OrderItemSkeleton() {
  return (
    <div className='flex w-full flex-col items-center justify-center gap-1'>
      <div className='w-[80%]'>
        <Skeleton
          variant='rounded'
          height={16}
          sx={{ width: '100%', marginBottom: '8px', borderRadius: '4px' }}
          animation='pulse'
        />
        <div className='grid min-h-[200px] w-full grid-cols-[45fr_55fr] gap-4 md:grid-cols-[25fr_75fr]'>
          <Skeleton
            variant='rounded'
            sx={{ height: '100%', width: '100%', borderRadius: '6px' }}
            animation='pulse'
          />
          <div className='flex flex-col'>
            <Skeleton
              variant='rounded'
              height={32}
              sx={{ width: '100%', borderRadius: '6px' }}
              animation='pulse'
            />
            <div className='max-w-[50%]'>
              <Skeleton
                variant='text'
                sx={{ fontSize: '1rem', width: '100%', marginTop: '20px' }}
                animation='pulse'
              />
              <Skeleton variant='text' sx={{ fontSize: '1rem', width: '100%' }} animation='pulse' />
              <Skeleton
                variant='text'
                sx={{ fontSize: '0.5rem', width: '100%', marginTop: '20px' }}
                animation='pulse'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
